import { render, staticRenderFns } from "./parambikulamTigerReserve.vue?vue&type=template&id=117dd401"
import script from "./parambikulamTigerReserve.vue?vue&type=script&lang=js"
export * from "./parambikulamTigerReserve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports